import styles from './SelectedFiltersList.module.scss';

import clsx from 'clsx';
import { forwardRef, useContext } from 'react';

import {
  Chip,
  ChipProps,
} from '@work4all/components/lib/dataDisplay/chip/Chip';

import { ToolbarFilterPickerContext } from '../ToolbarFilterPickerContext';

interface IFilterItem {
  id: string;
  title: string;
  readOnly: boolean;
  isPrimaryFilter?: boolean;
  filterActive?: boolean;
  handleDelete?: () => void;
  renderFilter: (item: React.ReactElement<any>) => React.ReactElement<any>;
}

export interface IFiltersListProps {
  list?: IFilterItem[];
  classes?: ChipProps['classes'];
}

export const SelectedFiltersList = forwardRef<
  HTMLUListElement,
  IFiltersListProps
>(function SelectedFiltersList(props, ref) {
  const toolbarPickerContext = useContext(ToolbarFilterPickerContext);

  if (!props.list || props.list.length === 0) {
    return null;
  }

  return (
    <ul ref={ref} className={styles.list}>
      {props.list.map((filterChip) => {
        return (
          <li key={filterChip.id}>
            {filterChip.renderFilter(
              <Chip
                disabled={filterChip.readOnly}
                color={filterChip.readOnly ? 'primary' : 'default'}
                label={filterChip.title}
                handleDelete={filterChip.handleDelete}
                maxWidth={18}
                onClick={() =>
                  toolbarPickerContext?.setFilterPickerActive(true)
                }
                className={clsx(styles.visibleChip, {
                  [styles.inActiveFilterChip]: !filterChip.handleDelete,
                  [props.classes?.root]: filterChip.handleDelete,
                })}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
});
